import { ApiResponse } from './api-response.interface';
import { ModelInterface } from './model.interface';

export interface UserModelInterface extends ModelInterface {
    id: number;
    username: string;
    first_name: string;
    last_name: string;
    email: string;
    date_joined: Date;
    roles?: string[];
    balance?: number;
}

export class UserModel implements UserModelInterface {
    public isMember = false;
    public isOperator = false;

    constructor(
        public id: number,
        public username: string,
        public first_name: string,
        public last_name: string,
        public email: string,
        public date_joined: Date,
        public balance: number = 0,
        public roles: string[] = []
    ) {
        this.isMember = this.roles.indexOf('barter-ledger-member') >= 0;
        this.isOperator = this.roles.indexOf('barter-ledger-operator') >= 0;
    }

    public static factory(userModel: UserModelInterface) {
        return new UserModel(
            userModel.id,
            userModel.username,
            userModel.first_name,
            userModel.last_name,
            userModel.email,
            userModel.date_joined,
            userModel.balance,
            userModel.roles
        );
    }
}

export type UserModelResponse = ApiResponse<UserModelInterface>;

export interface UserModelThinInterface {
    id: number;
    email: string;
}
